/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareArrowsCurveRightDown: {
  name: 'square-arrows-curve-right-down';
  data: string;
} = {
  name: 'square-arrows-curve-right-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a1 1 0 1 0-2 0v8H5V5h7a1 1 0 1 0 0-2H5Zm7.182 10.404c.185-1.19.536-2.366 1.166-3.374C14.39 8.363 16.294 7 20 7a1 1 0 1 0 0-2c-4.294 0-6.89 1.637-8.348 3.97-.925 1.48-1.348 3.17-1.53 4.739l-1.415-1.416a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414l-1.11 1.11Z" fill="currentColor"/></svg>`,
};
